/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddNewNoteAction.REQUEST_ADDNEWNOTE:
      return {
        ...state,
    };
    case actions.AddNewNoteAction.ADDNEWNOTE_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
